/**
 * Klientská zóna 2026 - správanie spoločné pre celý balík.
 *
 * Balík zámerne nenačítava Bootstrap JS, takže je všetko riešené ručne.
 */
(function () {
    'use strict';

    initHeaderNav();
    initPasswordToggles();
    initNewClientRegistration();
    initFormValidation();

    /**
     * Mobilné menu v hlavičke - pod breakpointom md je navigácia skrytá za
     * hamburgerom a rozbaľuje sa ako panel pod hlavičkou.
     */
    function initHeaderNav() {
        var toggler = document.querySelector('.kz-header__toggler');
        var nav = document.getElementById('kzHeaderNav');

        if (!toggler || !nav) {
            return;
        }

        var icon = toggler.querySelector('i');

        function isOpen() {
            return nav.classList.contains('is-open');
        }

        function setOpen(open) {
            nav.classList.toggle('is-open', open);
            toggler.setAttribute('aria-expanded', open ? 'true' : 'false');

            if (icon) {
                icon.classList.toggle('fa-bars', !open);
                icon.classList.toggle('fa-xmark', open);
            }
        }

        toggler.addEventListener('click', function (event) {
            event.stopPropagation();
            setOpen(!isOpen());
        });

        // Klik mimo panela ho zatvorí.
        document.addEventListener('click', function (event) {
            if (isOpen() && !nav.contains(event.target)) {
                setOpen(false);
            }
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && isOpen()) {
                setOpen(false);
                toggler.focus();
            }
        });

        // Po roztiahnutí okna nad mobilný breakpoint zrušíme otvorený stav,
        // aby panel nezostal "otvorený" v desktopovom rozložení.
        var desktop = window.matchMedia('(min-width: 768px)');
        var onChange = function (event) {
            if (event.matches) {
                setOpen(false);
            }
        };

        if (typeof desktop.addEventListener === 'function') {
            desktop.addEventListener('change', onChange);
        } else if (typeof desktop.addListener === 'function') {
            // Safari < 14
            desktop.addListener(onChange);
        }
    }

    /**
     * Zobrazenie / skrytie hesla.
     */
    function initPasswordToggles() {
        var toggles = document.querySelectorAll('[data-password-toggle]');

        Array.prototype.forEach.call(toggles, function (button) {
            var wrapper = button.closest('.kz-input');
            var input = wrapper ? wrapper.querySelector('.kz-input__control') : null;

            if (!input) {
                return;
            }

            // Ikony oka z Figmy - preškrtnuté pri skrytom hesle, otvorené pri
            // odkrytom (kz/partials/password-toggle).
            var eyeClosed = button.querySelector('[data-eye-closed]');
            var eyeOpen = button.querySelector('[data-eye-open]');
            // Prepínač sa používa aj mimo hesla (IČO pri zabudnutom hesle),
            // popis pre čítačky obrazovky si preto berie z atribútov.
            var labelShow = button.getAttribute('data-label-show') || 'Zobraziť heslo';
            var labelHide = button.getAttribute('data-label-hide') || 'Skryť heslo';

            button.addEventListener('click', function () {
                var reveal = input.type === 'password';

                input.type = reveal ? 'text' : 'password';
                button.setAttribute('aria-label', reveal ? labelHide : labelShow);

                if (eyeClosed && eyeOpen) {
                    eyeClosed.hidden = reveal;
                    eyeOpen.hidden = !reveal;
                }

                input.focus();
            });
        });
    }

    /**
     * Registrácia nového klienta - polia podľa kategórie a platiteľa DPH,
     * prílohy a drobné pomôcky pri vypĺňaní.
     *
     * Skryté pole sa zároveň vypne, takže ho prehliadač nekontroluje ani
     * neodošle. Počiatočný stav vykresľuje už server, tu sa len udržiava.
     */
    function initNewClientRegistration() {
        var form = document.querySelector('form[data-kz-new-client]');

        if (!form) {
            return;
        }

        var category = form.querySelector('#kategoria_klienta');
        var vatPayer = form.querySelector('#platitel_dph');

        function setApplicable(container, applicable) {
            container.hidden = !applicable;

            Array.prototype.forEach.call(container.querySelectorAll('input, select, textarea'), function (control) {
                if (control.type !== 'file') {
                    control.disabled = !applicable;
                    control.required = applicable;
                }
            });

            updateFile(container);

            if (!applicable) {
                clearFieldState(container);
            }
        }

        // Príloha je viditeľná vždy, pri výbere Áno/Nie len pri "Áno".
        function updateFile(container) {
            var widget = container.querySelector('[data-kz-file]');

            if (!widget) {
                return;
            }

            var toggle = container.querySelector('[data-kz-file-toggle]');
            var visible = !toggle || toggle.value === 'Áno';
            var input = widget.querySelector('input[type="file"]');
            var enabled = visible && !container.hidden;

            widget.hidden = !visible;
            input.disabled = !enabled;
            input.required = enabled;

            if (!visible) {
                widget.classList.remove('kz-file--error');
            }
        }

        function update() {
            var chosen = category.value;

            form.querySelector('[data-kz-category-sections]').hidden = chosen === '';
            form.querySelector('[data-kz-category-hint]').hidden = chosen !== '';

            Array.prototype.forEach.call(form.querySelectorAll('[data-kz-show-categories]'), function (container) {
                var categories = JSON.parse(container.getAttribute('data-kz-show-categories'));
                setApplicable(container, categories.indexOf(chosen) !== -1);
            });

            Array.prototype.forEach.call(form.querySelectorAll('[data-kz-show-vat]'), function (container) {
                setApplicable(container, !!vatPayer && vatPayer.value === 'Áno');
            });

            // Karta s prílohami by pri niektorých kategóriách ostala prázdna.
            var note = form.querySelector('[data-kz-no-attachments]');

            if (note) {
                var card = note.parentNode;
                note.hidden = card.querySelector('[data-kz-field]:not([hidden])') !== null;
            }
        }

        category.addEventListener('change', update);

        if (vatPayer) {
            vatPayer.addEventListener('change', update);
        }

        Array.prototype.forEach.call(form.querySelectorAll('[data-kz-file-toggle]'), function (toggle) {
            // Hlášku potom prepočíta kontrola na úrovni formulára.
            toggle.addEventListener('change', function () {
                updateFile(toggle.closest('[data-kz-field]'));
            });
        });

        Array.prototype.forEach.call(form.querySelectorAll('[data-kz-file]'), initFileInput);

        // Kód PZS, IBAN, IČ DPH sa ukladajú veľkými písmenami - prepíšeme
        // ich už pri písaní, aby prešla aj kontrola formátu.
        form.addEventListener('input', function (event) {
            var input = event.target;

            if (!input.hasAttribute || !input.hasAttribute('data-kz-uppercase')) {
                return;
            }

            var upper = input.value.toUpperCase();

            if (upper !== input.value) {
                var start = input.selectionStart;
                var end = input.selectionEnd;
                input.value = upper;
                input.setSelectionRange(start, end);
            }
        }, true);

        // "Nepridelené" v pomocnom texte kódu PZS
        Array.prototype.forEach.call(form.querySelectorAll('[data-kz-suggest]'), function (button) {
            button.addEventListener('click', function () {
                var input = form.querySelector('#' + button.getAttribute('data-kz-suggest'));

                input.value = button.textContent.trim().toUpperCase();
                input.dispatchEvent(new Event('input', {bubbles: true}));
                input.focus();
            });
        });

        update();
    }

    /**
     * Príloha - po výbere ukáže názov a veľkosť súboru s možnosťou ho
     * odstrániť, príliš veľký súbor označí ako neplatný.
     */
    function initFileInput(widget) {
        var input = widget.querySelector('input[type="file"]');
        var button = widget.querySelector('[data-kz-file-button]');
        var selected = widget.querySelector('[data-kz-file-selected]');
        var maxSize = parseInt(input.getAttribute('data-kz-max-size'), 10) || 0;

        function render() {
            var file = input.files && input.files[0];

            if (!file) {
                input.setCustomValidity('');
                button.hidden = false;
                selected.hidden = true;
                return;
            }

            input.setCustomValidity(
                maxSize && file.size > maxSize ? 'Súbor nesmie byť väčší ako 3 MB.' : ''
            );

            widget.querySelector('[data-kz-file-name]').textContent = file.name;
            widget.querySelector('[data-kz-file-size]').textContent = formatSize(file.size);
            button.hidden = true;
            selected.hidden = false;
        }

        // Obsluha na samotnom poli beží pred kontrolou na úrovni formulára.
        input.addEventListener('change', render);

        widget.querySelector('[data-kz-file-remove]').addEventListener('click', function () {
            input.value = '';
            render();
            input.dispatchEvent(new Event('change', {bubbles: true}));
            input.focus();
        });

        // Po návrate v histórii môže prehliadač súbor ešte držať.
        render();
    }

    /** Veľkosť v tvare z Figmy, napr. "1405KB". */
    function formatSize(bytes) {
        return Math.max(1, Math.round(bytes / 1024)) + 'KB';
    }

    /** Zruší chybový stav poľa, ktoré sa práve skrylo. */
    function clearFieldState(container) {
        Array.prototype.forEach.call(
            container.querySelectorAll('.kz-input--error, .kz-file--error'),
            function (element) {
                element.classList.remove('kz-input--error', 'kz-file--error');
            }
        );

        setFieldMessage(container.querySelector('[data-kz-field-error]'), '');
    }

    /**
     * Kontrola formulára pred odoslaním.
     *
     * Formuláre majú `novalidate`, takže prehliadač vlastné bubliny
     * nezobrazuje - hlášku vypíšeme pod dotknuté pole, rovnako ako to pri
     * odoslaní robí kontrolér. Overenie samotné robí štandardné Constraint
     * Validation API, ktoré `novalidate` neovplyvňuje.
     */
    function initFormValidation() {
        var forms = document.querySelectorAll('form[data-kz-validate]');

        Array.prototype.forEach.call(forms, function (form) {
            form.addEventListener('submit', function (event) {
                if (validateForm(form)) {
                    return;
                }

                event.preventDefault();

                var firstInvalid = form.querySelector(
                    '.kz-input--error .kz-input__control, .kz-checkbox--error .kz-checkbox__input, '
                    + '.kz-file--error .kz-file__input'
                );

                if (firstInvalid) {
                    // Pole prílohy je neviditeľné, posúvame na jeho obal.
                    var target = firstInvalid.closest('[data-kz-field]') || firstInvalid;
                    target.scrollIntoView({block: 'center'});
                    firstInvalid.focus({preventScroll: true});
                }
            });

            // Po úprave poľa sa kontrola zopakuje, takže hláška zmizne hneď,
            // ako je hodnota v poriadku.
            ['input', 'change'].forEach(function (type) {
                form.addEventListener(type, function (event) {
                    revalidateField(form, event.target);
                });
            });
        });
    }

    /**
     * Skontroluje celý formulár a vypíše hlášky. Vracia true, ak je v poriadku.
     */
    function validateForm(form) {
        var valid = true;

        Array.prototype.forEach.call(form.elements, function (field) {
            if (!isValidatable(field)) {
                return;
            }

            if (!applyFieldState(field)) {
                valid = false;
            }
        });

        var banner = form.querySelector('[data-kz-errors]');
        var captchaOk = captchaAnswered(form);

        if (banner) {
            setBanner(banner, captchaOk ? [] : ['Overte, či nie ste robot.']);
        }

        return valid && captchaOk;
    }

    /**
     * Prekontroluje jedno pole a keď je už všetko v poriadku, schová aj banner.
     */
    function revalidateField(form, field) {
        if (!isValidatable(field)) {
            return;
        }

        applyFieldState(field);

        var banner = form.querySelector('[data-kz-errors]');

        if (banner && captchaAnswered(form)) {
            setBanner(banner, []);
        }
    }

    function isValidatable(field) {
        return field && field.name && !field.disabled && typeof field.checkValidity === 'function';
    }

    /**
     * Označí alebo odznačí pole podľa jeho stavu. Vracia true, ak je platné.
     *
     * Jeden kontajner [data-kz-field] môže mať viac ovládacích prvkov (výber
     * a k nemu príloha) so spoločnou hláškou - vypíše sa hláška prvého
     * neplatného z nich.
     *
     * Kontrola celého formulára pred odoslaním volá túto funkciu pre každý
     * prvok, takže tam sa ukážu všetky chyby.
     */
    function applyFieldState(field) {
        var valid = field.checkValidity();
        var wrapper = field.closest('.kz-input, .kz-checkbox, .kz-file');

        if (wrapper) {
            var errorClass = wrapper.classList.contains('kz-checkbox') ? 'kz-checkbox--error'
                : (wrapper.classList.contains('kz-file') ? 'kz-file--error' : 'kz-input--error');
            wrapper.classList.toggle(errorClass, !valid);
        }

        var container = field.closest('[data-kz-field]');
        var message = container ? container.querySelector('[data-kz-field-error]') : null;
        var text = '';

        // Ostatné prvky kontajnera sa hlásia, len ak už chyba svieti - inak
        // by napr. výber "Áno" hneď vyčítal ešte nevybranú prílohu.
        if (container && (!valid || (message && !message.hidden))) {
            var controls = container.querySelectorAll('input, select, textarea');

            for (var i = 0; i < controls.length; i++) {
                if (isValidatable(controls[i]) && !controls[i].checkValidity()) {
                    text = fieldMessage(controls[i]);
                    break;
                }
            }
        } else if (!valid) {
            text = fieldMessage(field);
        }

        setFieldMessage(message, text);

        return valid;
    }

    /** Hláška zodpovedajúca dôvodu, prečo je pole neplatné. */
    function fieldMessage(field) {
        if (field.validity.customError) {
            return field.validationMessage;
        }

        if (field.validity.patternMismatch && field.getAttribute('data-kz-pattern-message')) {
            return field.getAttribute('data-kz-pattern-message');
        }

        if (field.validity.typeMismatch && field.type === 'email') {
            return 'Zadajte platnú e-mailovú adresu.';
        }

        return field.getAttribute('data-kz-message') || 'Vyplňte toto pole.';
    }

    function setFieldMessage(element, text) {
        if (!element) {
            return;
        }

        element.textContent = text;
        element.hidden = text === '';
    }

    function setBanner(banner, messages) {
        banner.innerHTML = '';

        messages.forEach(function (message) {
            var p = document.createElement('p');
            p.textContent = message;
            banner.appendChild(p);
        });

        banner.hidden = messages.length === 0;
    }

    /**
     * Je captcha vyriešená? Ak ju nevieme skontrolovať (widget sa nenačítal),
     * tvárime sa, že áno - overí ju server.
     */
    function captchaAnswered(form) {
        if (!form.querySelector('.g-recaptcha') || typeof grecaptcha === 'undefined') {
            return true;
        }

        try {
            return grecaptcha.getResponse().length > 0;
        } catch (e) {
            return true;
        }
    }
}());
